import { DASHBOARD_QUERY_NAMESPACE } from "../query-namespace";

export const DASHBOARD_WIDGET_QUERY_NAMESPACE = [...DASHBOARD_QUERY_NAMESPACE, "widget"];
